export default __webpack_public_path__ + "static/media/CircularStdBook.bb613914.woff2";